import React from 'react';
import { AlertProvider, AlertsFromProvider, BCR, Blue, ErrorCatcher, LoadingProvider } from 'best-common-react';
import { LariMessagingProvider } from '../contexts/LariMessaging';
import LariSecurity from '../components/auth/LariSecurity';

const WrapperProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ErrorCatcher appName="LARI" contactEmail="EBISSupport@mlb.com">
    <LariSecurity>
      <LariMessagingProvider>
        <AlertProvider>
          <BCR theme={Blue}>
            <LoadingProvider>
              <AlertsFromProvider />
              {children}
            </LoadingProvider>
          </BCR>
        </AlertProvider>
      </LariMessagingProvider>
    </LariSecurity>
  </ErrorCatcher>
);

export default WrapperProvider;
